import {
  Button,
  ButtonProps,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Typography,
  useTheme,
} from '@mui/material';
import * as React from 'react';

export type DataImportItemProps = {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  /** Shows the subtitle as a connected status, the way the Integrations cards do. */
  connected?: boolean;
  icon?: React.ReactNode;
  onClick: () => void;
  description: string;
  actionButtonText: string;
  actionButtonVariant?: ButtonProps['variant'];
  actionButtonTestId?: string;
};

export const DataImportItem = ({
  title,
  subTitle,
  connected = false,
  icon,
  onClick,
  description,
  actionButtonText,
  actionButtonVariant,
  actionButtonTestId,
}: DataImportItemProps) => {
  const theme = useTheme();
  return (
    <Card variant="outlined" sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <CardHeader
        avatar={icon}
        title={title}
        subheader={subTitle}
        slotProps={{
          subheader: {
            color: connected ? theme.palette.success.main : theme.palette.text.secondary,
          },
        }}
      />
      <CardContent sx={{ flexGrow: 1, pt: 0 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      </CardContent>
      <CardActions sx={{ m: theme.spacing() }}>
        <Button
          size="small"
          fullWidth
          variant={actionButtonVariant ?? 'contained'}
          onClick={onClick}
          color="primary"
          data-testid={actionButtonTestId}
        >
          {actionButtonText}
        </Button>
      </CardActions>
    </Card>
  );
};
